import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {currentResource} from '../../util/utils';
import _ from 'lodash';

export default function contentUpdateTypesReducer(
	state = initialstate.contentUpdateTypes,
	action
) {
	switch (action.type) {
		case types.GET_CONTENT_UPDATE_TYPES:
			return action.response;
			//return getContentUpdateTypes(action);
		default:
			return state;
	}
}

function getContentUpdateTypes(action) {
	let contentUpdateTypes = {};

	//var localizedEngagementUserRoles = currentResource.RoleForMember;
	//_.each(action.response, function(apiRole) {
	//	let localRole = localizedEngagementUserRoles.find(
	//		(x) => x.id == apiRole.id
	//	);
	//	let finalName = localRole ? localRole.role : apiRole.name;
	//	engagementUserRoles.push({
	//		id: apiRole.id,
	//		name: finalName
	//	});
	//});

	return contentUpdateTypes;
}
